import { Button, Checkbox, Form, Input, Modal, Radio, SideBar, Space, Swiper } from "antd-mobile";
import React, { useEffect, useRef, useState } from "react";
import { CloseOutline, AddOutline, MinusOutline } from 'antd-mobile-icons'
import ListItem from "./ListItem";
import Qty from "./Qty";
import Keyboard from "./Keyboard";
import FakeInput from "./FakeInput";
import FakeQty from "./FakeQty";
export default function Bar(props) {

    const {
        getInitial = () => { },
        globals = {},
        remove = () => { },
        increment = () => { },
        submit = () => { },
        search = () => { },
        selected = false,
        setSelected = () => { },
        searching = false,
        setSearching = () => { },
        filter = false,
        setFilter = () => { },
        oh = false,
        setOh = () => { },
        count = 1,
        setCount = () => { },
        keyboard = false,
        setKeyboard = () => { },
    } = props;

    const swiperRef = useRef();

    useEffect(() => {
        if (selected && swiperRef?.current) {
            swiperRef.current.swipeTo(1);
        } else {
            swiperRef.current.swipeTo(0);
        }
    }, [selected])


    const [input, setInput] = useState("");
    const [doneTrigger, setDoneTrigger] = useState(false);

    const [isbn, setISBN] = useState("")

    const parseISBN = (e) => {
        let _isbn = e.replace("~", "");
        setISBN(_isbn);
    }


    const confirmRemove = () => {
        const handler = Modal.show({
            title: "Remove confirmation",
            content: <>
                Are you sure you wish to remove this title?
                <br />
                <br />
                <div className="float-flex">
                    <div>&nbsp;</div>
                    <Space>
                        <Button onClick={() => handler.close()}>Cancel</Button>
                        <Button color="danger" onClick={() => {
                            remove(selected);
                            handler.close();
                        }}>Remove</Button>
                    </Space>
                </div>
            </>
        })
    }


    return (
        <div style={{ "marginTop": "-19px" }}>
            {(keyboard && <div onClick={() => setKeyboard(false)} style={{"position" : "absolute", "pointerEvents": "auto", "marginTop" : "-100vh", "backgroundColor" : "#00000088", "width" : "100%", "height" : "100vh"}}>&nbsp;</div>)}
            <div style={{ "height": "150px", "borderRadius": "3px", "padding": "0px", "border": (!searching && !selected) ? "4px solid #34b368" : (selected) ? "4px solid #333" : "4px solid #007EF5" }}>
                <Swiper indicator={() => <></>} allowTouchMove={false} ref={swiperRef}>
                    <Swiper.Item key={"new"}>
                        <Space>
                            <Space>
                                <div></div>


                                <div>
                                    <div className="shim" /><div className="shim" />
                                    <div style={{ "textAlign": "left", "paddingBottom": "5px", "paddingLeft": "2px", "opacity": "0.5" }}><strong>ISBN</strong> <small>{(searching && "SCAN TO SEARCH")} {(!searching && "SCAN TO ENTER")}</small></div>
                                    <div>
                                        <div>
                                            <FakeInput doneTrigger={doneTrigger} keyboard={keyboard} setInput={setInput} value={input} setKeyboard={setKeyboard} name="isbn" width={145} onChange={(e) => {
                                                if (searching) {
                                                    search(e);
                                                } else {
                                                    submit(e, count, false, true);
                                                }
                                            }} />
                                            {/* <Form.Item className="bottom-input" style={{ "textAlign": "left", "backgroundColor": "#2b2b2b" }}>
                                                <Input onFocus={(e) => e.target.select()} placeholder="Scan / Enter" inputMode="search" value={isbn} onEnterPress={(e) => {
                                                    if (searching) {
                                                        search(e.target.value);
                                                    } else {
                                                        submit(e.target.value, count, false, true);
                                                    }
                                                    setISBN(""); e.target.blur()
                                                }} onChange={(e, f) => parseISBN(e)} id="manual" style={{ "width": "145px" }} />
                                            </Form.Item> */}
                                        </div>
                                    </div>
                                </div>

                                {(!searching &&

                                    <div style={{ "paddingLeft": "0px" }}>
                                        <div className="shim" /><div className="shim" />
                                        <div style={{ "textAlign": "left", "paddingBottom": "5px", "paddingLeft": "2px", "opacity": "0.5" }}><strong>QTY</strong></div>
                                        <div>
                                            <Space direction="horizontal" style={{ "gap": "0px", "--gap-horizontal": "0px", "--gap-vertical": "0px" }}>
                                                <Button onClick={() => setCount((count - 1 === 0) ? count - 2 : count - 1)} color="default" style={{ "borderRadius": "0px", "width": "50px", "height": "49px", "border": "4px solid #2b2b2b" }}><MinusOutline /></Button>

                                                <FakeQty persist placeholder="Qty" number keyboard={keyboard} setInput={setInput} input={input} value={count} setKeyboard={setKeyboard} name="qty" width={40} onChange={(e) => setCount(e)} />

                                                {/* <Form.Item className="bottom-input" style={{ "textAlign": "left", "backgroundColor": "#2b2b2b" }}>
                                                    <Qty width={40} count={count} setCount={setCount} />
                                                </Form.Item> */}
                                                <Button onClick={() => setCount((count + 1 === 0) ? count + 2 : count + 1)} color="default" style={{ "borderRadius": "0px", "width": "50px", "height": "49px", "border": "4px solid #2b2b2b" }}><AddOutline /></Button>
                                            </Space>
                                        </div>
                                    </div>
                                )}

                                {(searching &&
                                    <div style={{ "paddingLeft": "0px" }}>
                                        <div className="shim" /><div className="shim" />
                                        <Space>
                                            <div style={{ "textAlign": "left", "paddingBottom": "5px", "paddingLeft": "2px", "opacity": "0.5" }}><span>DIFF ONLY</span></div>
                                            <div></div>
                                            <div style={{ "textAlign": "left", "paddingBottom": "5px", "paddingLeft": "2px", "opacity": "0.5" }}><span>#{globals.station} ONLY</span></div>
                                        </Space>
                                        <br />
                                        <Space>
                                            <Button onClick={() => {

                                                if (searching && searching !== true) {
                                                    setSearching(true);
                                                }
                                                setOh(!oh)

                                            }} style={{ "border": "none", "height": "50px" }} color={"default"} size="large" shape='rectangular' block>
                                                <small><small>&nbsp;&nbsp;&nbsp;&nbsp;<Checkbox checked={oh} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small></small>
                                            </Button>
                                            <Button onClick={() => {
                                                if (searching && searching !== true) {
                                                    setSearching(true);
                                                }
                                                setFilter(!filter)

                                            }} style={{ "border": "none", "height": "50px" }} color={"default"} size="large" shape='rectangular' block>
                                                <small><small><Checkbox checked={filter} /></small></small>
                                            </Button>
                                        </Space>

                                    </div>

                                )}



                            </Space>
                        </Space>
                        <div className="shim" /><div className="shim" />
                        <div style={{ "display": "flex", "width": "100%", "marginTop": "-8px" }}>
                            <Button onClick={() => {
                                setSearching(false);


                            }} style={{ "border": "none", "height": "60px", "backgroundColor": (searching) ? "#000" : "#34b368" }} color={"success"} size="large" shape='rectangular' block>
                                <small><small>NEW (#{globals.station})</small></small>
                            </Button>
                            <Button onClick={() => { setSearching(true); }} style={{ "border": "none", "height": "60px", "backgroundColor": (!searching) ? "#000" : "#007EF5" }} color={"primary"} size="large" shape='rectangular' block>
                                <small><small>BROWSE</small></small>
                            </Button>
                            {/* <Button onClick={() => setFilter(!filter)} style={{ "border": "none", "height": "60px" }} color={"default"} size="large" shape='rectangular' block>
                                <small><small><Checkbox checked={filter} /> &nbsp; #{globals.station} Only</small></small>
                            </Button> */}
                        </div>

                    </Swiper.Item>




                    <Swiper.Item key={"edit"}>


                        <ListItem
                            increment={() => { }}
                            leftActions={[]}
                            rightActions={[]}
                            selected={selected}
                            setSelected={setSelected}
                            noswipe
                            item={selected} />

                        <div style={{ "display": "flex", "marginTop": "-5px" }}>

                            <Space direction="horizontal" style={{ "gap": "0px", "--gap-horizontal": "0px", "--gap-vertical": "0px" }}>
                                <Button onClick={() => increment(selected, -1, false)} color="default" style={{ "borderRadius": "0px", "width": "50px", "height": "49px", "border": "4px solid #2b2b2b" }}><MinusOutline /></Button>


                                <FakeQty placeholder="Qty" number keyboard={keyboard} setInput={setInput} input={input} value={selected.counted} setKeyboard={setKeyboard} name="qty2" width={40} onChange={(e) => {


                                    increment(selected, e, false, false);

                                }} />
                                {/* <Form.Item className="bottom-input" style={{ "textAlign": "left", "backgroundColor": "#2b2b2b" }}>

                                    <Qty fallback={0} count={selected.counted} setCount={(_amount) => {
                                        increment(selected, _amount, false, false);
                                    }} />
                                </Form.Item> */}
                                <Button onClick={() => increment(selected, 1, false)} color="default" style={{ "borderRadius": "0px", "width": "50px", "height": "49px", "border": "4px solid #2b2b2b" }}><AddOutline /></Button>
                            </Space>
                            <div style={{ "width": "10px" }}></div>
                            <Button onClick={() => setSelected(false)} style={{ "border": "none", "height": "49px", "backgroundColor": "#007EF5" }} color={"success"} size="large" shape='rectangular' block>
                                <small><small>CLOSE</small></small>
                            </Button>


                            <div style={{ "width": "10px" }}></div>
                            <Button onClick={() => confirmRemove()} style={{ "border": "none", "height": "49px", "backgroundColor": "#a65959" }} color={"success"} size="large" shape='rectangular' block>
                                <small><small>REMOVE</small></small>
                            </Button>
                        </div>


                    </Swiper.Item>
                </Swiper>
            </div>


            <Keyboard doneTrigger={doneTrigger} setDoneTrigger={setDoneTrigger} input={input} setInput={setInput} keyboard={keyboard} setKeyboard={setKeyboard} />


        </div>
    )
}